module.exports = __webpack_public_path__ + "img/link-class.f343bc43.svg";